export const MAP_SETTINGS_HEATMAP_ADD_HEATMAP = 'MAP_SETTINGS_HEATMAP/ADD_HEATMAP';
export const MAP_SETTINGS_HEATMAP_RESET_HEATMAPS = 'MAP_SETTINGS_HEATMAP/RESET_HEATMAPS';
export const MAP_SETTINGS_HEATMAP_REMOVE_HEATMAP = 'MAP_SETTINGS_HEATMAP/REMOVE_HEATMAP';
export const MAP_SETTINGS_HEATMAP_UPDATE_HEATMAP = 'MAP_SETTINGS_HEATMAP/UPDATE_HEATMAP';
